import * as React from 'react';
import { useState } from 'react';
import { Dialog } from '@fluentui/react/lib/Dialog';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { useTranslation } from 'react-i18next';

import { _dataProvider } from '../dataProvider/DataProvider';
import { IChatMessage } from '../dataProvider/IChatData';
import { _smallScreen } from '../SharedCommon/utils';
import i18n from '../i18n';
import './Org.css';
import './Dialog.css';

export interface IPromptPickFilesInGroupProps {
  groupId: number;
  processFile: (groupId: number, fileId: number) => Promise<void>;
  onDismiss: () => void;
}

export const IPromptPickFilesInGroup: React.FunctionComponent<IPromptPickFilesInGroupProps> = (props) => {
  const [fileList, setFileList] = useState<IChatMessage[] | undefined | null>(undefined);
  const { t } = useTranslation();
  const [dayRange, setDayRange] = useState(36);

  React.useEffect(() => {
    const getFiles = async () => {
      const files = await _dataProvider.getFileListInGroup(props.groupId, dayRange);
      setFileList(files);
    };
    getFiles();
  }, [dayRange, props.groupId]);

  const fileName = (name: string) => {
    if (name.startsWith('文件 ') || name.startsWith('音频 ') || name.startsWith('图片 ')) {
      return name.slice(3);
    }
    return name;
  };

  const title =
    fileList === undefined
      ? t('Loading', 'Loading...')
      : fileList === null
        ? t('ServerErrorRetry', 'Server error, please try again')
        : fileList.length === 0
          ? t('NoFile')
          : t('ChooseFile');

  return (
    <Dialog
      hidden={false}
      onDismiss={() => {
        props.onDismiss();
      }}
      dialogContentProps={{
        showCloseButton: true,
        title
      }}
      modalProps={{
        isBlocking: false,
        styles: {
          main: {
            borderRadius: '20px',
            width: 'min(480px, calc(100vw - 32px))',
            minWidth: 0,
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: 'calc(100vh - 80px)'
          }
        },
        containerClassName: 'PickGroupDialogue'
      }}
    >
      <div className='PickGroup PickGroup--files' data-is-scrollable='true'>
        {!!fileList &&
          fileList.map((item: IChatMessage, index) => (
            <ul key={index} className='buttonColor' style={{ padding: 0 }}>
              <DefaultButton
                className='orgGroupButton'
                style={{ width: '100%', padding: 4, borderRadius: 0 }}
                styles={{
                  flexContainer: {
                    marginLeft: 8
                  }
                }}
                onClick={() => props.processFile(props.groupId, item.fileId)}
              >
                {!_smallScreen && (
                  <div style={{ width: '100%' }}>
                    <p style={{ float: 'left' }}>{new Date(item.time * 1000).toLocaleDateString()}</p>
                    <p style={{ float: 'right' }}>{fileName(item.displayName)}</p>
                  </div>
                )}
                {_smallScreen && fileName(item.displayName)}
              </DefaultButton>
            </ul>
          ))}
        {dayRange === 36 && !!fileList && fileList.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <DefaultButton
              className='orgGroupButton'
              style={{ backgroundColor: 'lightgray', marginTop: 16 }}
              styles={{
                flexContainer: {
                  marginLeft: 25
                }
              }}
              onClick={() => setDayRange(178)}
            >
              {i18n.t('Chatroom.HalfYear')}
            </DefaultButton>
          </div>
        )}
      </div>
    </Dialog>
  );
};
